module.exports = __webpack_public_path__ + "img/versapay-interviews-1.c809f5b7.png";